/* Marcas de «intro» y «créditos» que dan Jellyfin, Emby y Plex. Módulo puro: solo normaliza lo que cada servidor cuenta. */

const MIN_SECS = 5; // más corto que esto no merece un botón

/**
 * Lista cualquiera de { type, start, end } en segundos → las válidas, ordenadas, sin solaparse y con `type` 'intro' o 'credits'.
 * `duration` (segundos, opcional) recorta lo que se pase del final.
 */
export function cleanSegments(list, duration = 0) {
    const out = [];
    (list || []).forEach((s) => {
        const type = s && (s.type === 'intro' || s.type === 'credits') ? s.type : '';
        let start = Number(s && s.start);
        let end = Number(s && s.end);
        if (!type || !Number.isFinite(start) || !Number.isFinite(end)) return;
        if (duration > 0) end = Math.min(end, duration);
        start = Math.max(0, start);
        if (end - start < MIN_SECS) return;
        out.push({ type, start: Math.round(start * 10) / 10, end: Math.round(end * 10) / 10 });
    });
    out.sort((a, b) => a.start - b.start);
    // Solapadas: se queda la primera
    return out.filter((s, i) => i === 0 || s.start >= out[i - 1].end);
}

/** Capítulos de Jellyfin/Emby con `MarkerType` (IntroStart, IntroEnd, CreditsStart…) → segmentos. Los tiempos van en «ticks» de 100 ns. */
export function segmentsFromChapters(chapters, durationSecs = 0, ticks = 10000000) {
    const at = (type) => {
        const c = (chapters || []).find((x) => String(x.MarkerType || '') === type);
        return c && c.StartPositionTicks != null ? Number(c.StartPositionTicks) / ticks : null;
    };
    const out = [];
    const introStart = at('IntroStart');
    const introEnd = at('IntroEnd');
    if (introStart != null && introEnd != null) out.push({ type: 'intro', start: introStart, end: introEnd });
    const credits = at('CreditsStart');
    if (credits != null && durationSecs > credits) out.push({ type: 'credits', start: credits, end: durationSecs });
    return cleanSegments(out, durationSecs);
}
